export default {
  Open: 'open',
  Canceled: 'canceled',
  PartialFill: 'partial_fill',
  Filled: 'filled',
};
